import { TwoColumnLayout } from '@factorialco/f0-react'

import MainContent from './_MainContent'
import SideContent from './_SideContent'
import type { MergedField, SectionType } from './types'

type NumerationState = {
  prefix: string
  nextNumber: number | null
}

type NumerationErrors = {
  prefix?: string
  nextNumber?: string
}

type Props = {
  fields: MergedField[]
  numeration: NumerationState
  numerationErrors?: NumerationErrors
  onToggleVisibility: (fieldKey: string, newVisible: boolean) => void
  onAddCustomField: (
    section: SectionType,
    label: string,
    fieldType: 'text' | 'select',
    options: string[]
  ) => void
  onNumerationChange: (numeration: NumerationState) => void
}

function FieldEditor({
  fields,
  numeration,
  numerationErrors,
  onToggleVisibility,
  onAddCustomField,
  onNumerationChange,
}: Props) {
  return (
    <TwoColumnLayout
      mainColumnPosition="right"
      sideContent={
        <SideContent
          fields={fields}
          numeration={numeration}
          numerationErrors={numerationErrors}
          onToggleVisibility={onToggleVisibility}
          onAddCustomField={onAddCustomField}
          onNumerationChange={onNumerationChange}
        />
      }
    >
      <MainContent fields={fields} numeration={numeration} />
    </TwoColumnLayout>
  )
}

export type { NumerationState, NumerationErrors }
export default FieldEditor
